<template>
  <section id="response_message" class="py-8 px-4">
    <div class="pb-8">
      <h2 class="text-center speedee-bd text-3xl pb-8">
        Datenänderung - Geburtstagsbrief
      </h2>
    </div>
    <div
      class="md:w-9/12 m-auto shadow-mcd-form rounded-mcd-lg px-4 md:px-12 lg:px-24 xl:px-48"
    >
      <!-- preloader START -->
      <Preloader v-if="submitStatus == 'LOADING'" />
      <!-- preloader END -->
      <div class="py-16 items-center justify-center" v-if="response.message">
        <h2 class="text-center speedee-bd text-3xl pb-8">
          {{ response.message }}
        </h2>
        <p>
          Deine Daten wurden nicht gespeichert. Klicke
          <a href="/familyplus" class="underline">hier</a>, um dich noch einmal
          anzumelden.
        </p>
      </div>
      <div v-else class="py-16">
        <!-- E-Mail START -->
        <div class="pt-4">
          <input
            class="w-full bg-white h-14 px-5 rounded focus:outline-none cursor-default"
            :class="[
              submitStatus == 'ERROR' && !$v.email.email ? 'error' : '',
              submitStatus == 'ERROR' && !$v.email.required ? 'error' : '',
            ]"
            type="email"
            name="email"
            placeholder="E-Mail*"
            v-model.trim="$v.email.$model"
            readonly
          />
          <div class="text-red-600 text-sm pt-2">
            <p v-if="submitStatus == 'ERROR' && !$v.email.required">
              Erforderlich
            </p>
            <p v-if="submitStatus == 'ERROR' && !$v.email.email">
              Eine gültige E-Mail-Adresse ist erforderlich.
            </p>
          </div>
        </div>
        <!-- E-Mail END -->
        <!-- GB START -->
        <div class="pt-8">
          <template>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4">
              <div>
                <input
                  class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                  type="text"
                  name="gb_name"
                  placeholder="Vorname Elternteil*"
                  v-model.trim="$v.gb.gb_name.$model"
                  :class="[
                    submitStatus == 'ERROR' && !$v.gb.gb_name.required
                      ? 'error'
                      : '',
                  ]"
                />
                <div class="text-red-600 text-sm pt-1 md:pt-2">
                  <p v-if="submitStatus == 'ERROR' && !$v.gb.gb_name.required">
                    Erforderlich
                  </p>
                </div>
              </div>
              <div>
                <input
                  class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                  type="text"
                  name="gb_lastname"
                  placeholder="Nachname Elternteil*"
                  v-model.trim="$v.gb.gb_lastname.$model"
                  :class="[
                    submitStatus == 'ERROR' && !$v.gb.gb_lastname.required
                      ? 'error'
                      : '',
                  ]"
                />
                <div class="text-red-600 text-sm pt-2">
                  <p
                    v-if="
                      submitStatus == 'ERROR' && !$v.gb.gb_lastname.required
                    "
                  >
                    Erforderlich
                  </p>
                </div>
              </div>
            </div>
            <!-- Name, last name GB END -->
            <!-- Address GB START -->
            <div class="grid grid-cols-4 gap-x-4 gap-y-1 pt-1">
              <div class="col-span-4 md:col-span-2">
                <input
                  class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                  type="text"
                  name="gb_street"
                  placeholder="Straße*"
                  v-model.trim="$v.gb.gb_street.$model"
                  :class="[
                    submitStatus == 'ERROR' && !$v.gb.gb_street.required
                      ? 'error'
                      : '',
                  ]"
                />
                <div class="text-red-600 text-sm pt-2">
                  <p
                    v-if="submitStatus == 'ERROR' && !$v.gb.gb_street.required"
                  >
                    Erforderlich
                  </p>
                </div>
              </div>
              <div class="col-span-2 md:col-span-1">
                <input
                  class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                  type="text"
                  name="gb_number"
                  placeholder="Hausnr.*"
                  v-model.trim="$v.gb.gb_number.$model"
                  :class="[
                    submitStatus == 'ERROR' && !$v.gb.gb_number.required
                      ? 'error'
                      : '',
                  ]"
                />
                <div class="text-red-600 text-sm pt-2">
                  <p
                    v-if="submitStatus == 'ERROR' && !$v.gb.gb_number.required"
                  >
                    Erforderlich
                  </p>
                </div>
              </div>
              <div class="col-span-2 md:col-span-1">
                <input
                  class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                  type="text"
                  name="gb_top"
                  placeholder="Top/Stiege"
                  v-model="gb.gb_top"
                />
              </div>
              <div class="col-span-4 md:col-span-1">
                <input
                  class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                  type="text"
                  name="gb_plz"
                  placeholder="PLZ*"
                  v-model.trim="$v.gb.gb_plz.$model"
                  :class="[
                    submitStatus == 'ERROR' && !$v.gb.gb_plz.required
                      ? 'error'
                      : '',
                  ]"
                />
                <div class="text-red-600 text-sm pt-2">
                  <p v-if="submitStatus == 'ERROR' && !$v.gb.gb_plz.required">
                    Erforderlich
                  </p>
                </div>
              </div>
              <div class="col-span-4 md:col-span-3">
                <input
                  class="w-full bg-white h-14 px-5 rounded focus:outline-none"
                  type="text"
                  name="gb_city"
                  placeholder="Ort*"
                  v-model.trim="$v.gb.gb_city.$model"
                  :class="[
                    submitStatus == 'ERROR' && !$v.gb.gb_city.required
                      ? 'error'
                      : '',
                  ]"
                />
                <div class="text-red-600 text-sm pt-2">
                  <p v-if="submitStatus == 'ERROR' && !$v.gb.gb_city.required">
                    Erforderlich
                  </p>
                </div>
              </div>
            </div>
          </template>
          <!-- Name, month, year GB child START -->
          <template>
            <div v-for="(child, index) in gb.gb_childs" :key="index">
              <GbChild :child="child" ref="childrenComponent" />
              <!-- Remove Child START -->
              <div v-if="index > 0" class="mt-6 md:mt-0">
                <div
                  class="inline-block bg-mcdonalds-gray px-4 py-2 rounded-full mt-4 w-full md:w-60 shadow-mcd"
                >
                  <div class="flex items-center justify-between">
                    <div class="inline-block pl-2 speedee-bd text-sm">
                      Kind entfernen
                    </div>
                    <div class="inline-block">
                      <div
                        class="flex justify-center items-center w-8 h-8 md:w-6 md:h-6 text-white speedee-bd cursor-pointer ml-4"
                        @click="removeChild(index)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 50 50"
                          class="fill-current stroke-current stroke-2 w-6 h-6 md:w-5 md:h-5"
                        >
                          <g>
                            <path d="M4.3,28.53v-7.18h41.4v7.18H4.3z" />
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Remove Child END -->
            </div>
          </template>
          <!-- Add Child START -->
          <div v-if="gb.gb_childs.length < 4" class="mb-12 md:mb-0">
            <div
              class="inline-block bg-mcdonalds-yellow px-4 py-2 rounded-full mt-4 w-full md:w-60 shadow-mcd"
            >
              <div class="flex items-center justify-between">
                <div class="inline-block pl-2 speedee-bd text-sm">
                  Weiteres Kind hinzufügen
                </div>
                <div class="inline-block">
                  <div
                    class="flex justify-center items-center w-8 h-8 md:w-6 md:h-6 text-white speedee-bd cursor-pointer ml-4"
                    @click="addChild"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 50 50"
                      class="fill-current stroke-current stroke-2 w-6 h-6 md:w-5 md:h-5"
                    >
                      <g>
                        <path
                          d="M21.36,45.7V28.53H4.3v-7.18h17.07V4.3h7.27v17.05H45.7v7.18H28.64V45.7H21.36z"
                        />
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Add Child END -->
          <!-- Check box GB START -->
          <label class="flex justify-start items-start pt-8">
            <div
              class="rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
              :class="[
                submitStatus == 'ERROR' && $v.gb.isVisible.$error
                  ? 'error'
                  : '',
                gb.isVisible ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray',
              ]"
            >
              <input
                type="checkbox"
                name="gb"
                class="opacity-0 absolute"
                v-model="gb.isVisible"
              />
              <svg
                class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            </div>
            <div class="select-none font-light">
              *Ich stimme in meinem Namen und im Namen meines Kindes (meiner
              Kinder) zu, dass die McDonald's Werbegesellschaft m.b.H. die
              angegebenen Daten verarbeitet, um mir für mein Kind (meine Kinder)
              (im Alter zwischen 3 und 12 Jahren) einen Geburtstagsgutschein per
              Post zusendet. Diese Zustimmung kann ich auch nachträglich
              jederzeit gegenüber McDonald’s per E-Mail an
              datenschutz@at.mcd.com widerrufen. Der Widerruf lässt die
              Rechtmäßigkeit der Verarbeitung bis zum Widerruf unberührt.
            </div>
          </label>
          <!-- Check box GB END -->
          <!-- Name, month, year GB child END -->
          <!-- Address GB END -->
        </div>
        <!-- GB END -->
        <div class="pt-4">
          <!-- Check box GPDR START -->
          <label class="flex justify-start items-start pb-2">
            <div
              class="rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-4"
              :class="[
                submitStatus == 'ERROR' && $v.checkConditions.$error
                  ? 'error'
                  : '',
                checkConditions ? 'bg-mcdonalds-yellow' : 'bg-mcdonalds-gray',
              ]"
            >
              <input
                type="checkbox"
                name="tipi"
                class="opacity-0 absolute"
                v-model.trim="checkConditions"
                @change="$v.checkConditions.$touch()"
              />
              <svg
                class="fill-current stroke-current stroke-2 hidden w-3 h-3 text-white pointer-events-none"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            </div>
            <div class="select-none font-light">
              *Ich stimme den
              <a
                href="https://www.mcdonalds.at/familyplus/agb"
                class="underline text-mcdonalds-yellow"
                >Nutzungsbedingungen</a
              >
              zu und nehme die
              <a
                href="https://www.mcdonalds.at/datenschutz"
                class="underline text-mcdonalds-yellow"
                >Datenschutzerklärung</a
              >
              zur Kenntnis.
            </div>
          </label>
          <!-- Check box GPDR END -->
        </div>
        <div class="flex justify-center pt-12">
          <button
            class="bg-mcdonalds-yellow rounded-full py-4 px-16 text-black text-xl speedee-bd mt-4 focus:outline-none"
            @click="validateForm()"
          >
            Änderungen speichern
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gbChildMixin } from "../mixins";
import Preloader from "./Preloader";
import GbChild from "./GbChild";
import { ValidationRulesEdit } from "./ValidationRulesEdit.js";

export default {
  components: {
    GbChild,
    Preloader,
  },
  data() {
    return {
      submitStatus: null,
      response: {
        status: null,
        message: "",
      },
      guid: "",
      email: "",
      nl: false,
      tipi: {
        isVisible: false,
      },
      gb: {
        isVisible: false,
        gb_name: "",
        gb_lastname: "",
        gb_street: "",
        gb_number: null,
        gb_top: "",
        gb_plz: null,
        gb_city: "",
        gb_childs: [],
        gb_child_db: [],
      },
      checkConditions: false,
      validationSuccessChildren: false,
    };
  },
  validations() {
    return ValidationRulesEdit;
  },
  mixins: [gbChildMixin],
  methods: {
    // method to validate child components
    async validateForm() {
      // run vuelidate and check if there some errors
      this.$v.$touch();
      // if checkbox is checked/true
      if (this.gb.isVisible) {
        // then run loop trough array and check each component validation.
        for (const [i, child] of this.gb.gb_childs.entries()) {
          // call method submit in each child component
          this.$refs.childrenComponent[i].submit();
          // if validation is success, then set value to true
          if (child.validationSuccess) {
            this.validationSuccessChildren = true;
          } else {
            this.validationSuccessChildren = false;
          }
        }
      }

      // if validation is false
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        // add child to gb child
        if (this.gb.gb_childs.length > 0) {
          this.generateChildrenArray();
        }

        let formData = new FormData();
        // create a json object from values to send to API
        let data = {
          guid: this.guid,
          gb: this.gb.isVisible,
          gb_name: this.gb.gb_name,
          gb_lastname: this.gb.gb_lastname,
          gb_street: this.gb.gb_street,
          gb_number: this.gb.gb_number,
          gb_top: this.gb.gb_top,
          gb_plz: this.gb.gb_plz,
          gb_city: this.gb.gb_city,
          gb_childs: this.gb.gb_child_db,
        };

        formData.append("data", JSON.stringify(data));

        if (this.gb.isVisible || this.tipi.isVisible || this.nl) {
          // if validation is true, but if child checkbox is checked/true
          if (this.gb.isVisible && this.validationSuccessChildren) {
            const registerUser = await this.setData(formData);
            this.submitStatus = "OK";
            this.scrollToId();
          }
        } else {
          this.$swal({
            icon: "error",
            title:
              "Hoppla, du hast kein Angebot ausgewählt. Versuch‘s nochmal!",
          });
        }
      }
    },
    async setData(formData) {
      //setup headers, method and values
      const settings = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "X-Requested-With": "XMLHttpRequest",
        },
      };

      this.submitStatus = "LOADING";
      this.axios
        .post(
          process.env.VUE_APP_WEBSERVICE_URL + "/?action=setgbdata",
          formData,
          settings
        )
        .then(
          // get response if success
          async (dataRes) => {
            if (dataRes.data.success) {
              this.submitStatus = "OK";
              this.$swal({
                icon: "success",
                title:
                  "Danke für dein Update! Deine Daten wurden erfolgreich geändert.",
                showConfirmButton: false,
                html:
                  '<div class="my-8"><a href="https://www.mcdonalds.at/familyplus" class="bg-blue-600 rounded-md py-4 px-8 text-white text-2xl speedee-bd mt-4 swal2-confirm swal2-styled">OK</a></div>',
                allowOutsideClick: false,
              });
            } else if (dataRes.data.error) {
              this.response.status = "Error";
              this.response.message =
                "Leider ist der Link abgelaufen oder die Daten wurden bereits geändert.";
              this.submitStatus = "ERROR";
            } else {
              console.log(dataRes.data);
            }
          }
          // catch the errors
        )
        .catch(function(error) {});
    },
    async getData(guid) {
      let formData = new FormData();

      // create a json object from values to send to API
      let data = {
        guid: guid,
      };

      let germanMonths = [
        "Jänner",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember",
      ];

      formData.append("data", JSON.stringify(data));
      //setup headers, method and values
      const settings = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "X-Requested-With": "XMLHttpRequest",
        },
      };
      this.submitStatus = "LOADING";
      this.axios
        .post(
          process.env.VUE_APP_WEBSERVICE_URL + "/?action=getgbdata",
          formData,
          settings
        )
        .then(
          // get response if success
          async (dataRes) => {
            this.submitStatus = null;
            let participant = dataRes.data.success;
            if (participant) {
              this.email = participant.email;
              this.gb.gb_name = participant.gb_name;
              this.gb.gb_lastname = participant.gb_lastname;
              this.gb.gb_street = participant.gb_street;
              this.gb.gb_number = participant.gb_number;
              this.gb.gb_top = participant.gb_top;
              this.gb.gb_plz = participant.gb_plz;
              this.gb.gb_city = participant.gb_city;
              participant.gb_childs.forEach((child) => {
                this.gb.gb_childs.push({
                  name: child.name,
                  month: {
                    isVisible: false,
                    value: germanMonths[child.month - 1],
                  },
                  year: {
                    isVisible: false,
                    value: child.year != 0 ? child.year : null,
                  },
                });
              });
            } else {
              this.response.status = "Error";
              this.response.message =
                "Leider ist der Link abgelaufen oder die Daten wurden bereits geändert.";
            }
          }
          // catch the errors
        )
        .catch(function(error) {});
    },
  },
  async mounted() {
    // scroll to id
    const id = "response_message";
    const yOffset = -100;
    const element = document.getElementById(id);
    const y =
      element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });

    this.tipi.isVisible = false;
    // on load check if url params are set and set the in a variable
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    // get paramaters by name
    const changegb = urlParams.get("changegb");
    if (changegb) {
      this.guid = changegb;
      const getEditDataDb = await this.getData(this.guid);
    }
  },
};
</script>
